/* eslint-disable react/prop-types, react/jsx-handler-names */

import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Select from 'react-select'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import NoSsr from '@material-ui/core/NoSsr'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import Chip from '@material-ui/core/Chip'
import MenuItem from '@material-ui/core/MenuItem'
import CancelIcon from '@material-ui/icons/Cancel'
import { emphasize } from '@material-ui/core/styles/colorManipulator'

const styles = theme => ({
  // seems not affected
  root: {
    flexGrow: 1,
    //this height controls the size overall, was 5px, too small
    height: '35px',
    //adjust to align all the inputs
    padding: '0px 0px 0px 20px'
  },
  input: {
    display: 'flex',
    padding: 0,
    //this height contral the textfield
    //height: '60px', // 60px is good for user form
    margin: '0px 0px',
    // fontSize: '14px',
    // fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    // fontWeight: '400',
    // lineHeight: '1.42857'
    height: '1.8em' // this is good for request form
  },
  looseInput: {
    height: '60px'
    // verticalAlign: 'bottom'
  },
  looseRoot: {
    padding: '0px',
    height: '60px'
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden'
  },
  chip: {
    margin: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 4}px`
  },
  chipFocused: {
    backgroundColor: emphasize(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08)
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`
  },
  singleValue: {
    fontSize: 16
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
    wordWrap: 'break-word'
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing.unit,
    left: 0,
    right: 0
  },
  divider: {
    height: theme.spacing.unit * 2
  }
  // control: {
  //   height: '100px'
  // }

  //https://stackoverflow.com/questions/49848999/how-to-reduce-the-size-of-react-select-in-v2
})

function NoOptionsMessage(props) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.noOptionsMessage} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

function inputComponent({ inputRef, ...props }) {
  return <div ref={inputRef} {...props} />
}

function Control(props) {
  // console.log(props)
  return (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: classNames({
            [props.selectProps.classes.input]: true,
            [props.selectProps.classes.looseInput]: props.selectProps.loose
          }),
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps
        }
      }}
      {...props.selectProps.textFieldProps}
    />
  )
}

function Option(props) {
  // console.log(props)
  return (
    <MenuItem
      buttonRef={props.innerRef}
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400
      }}
      {...props.innerProps}
    >
      {props.children}
    </MenuItem>
  )
}

function Placeholder(props) {
  return (
    <Typography color="textSecondary" className={props.selectProps.classes.placeholder} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

function SingleValue(props) {
  return (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  )
}

function ValueContainer(props) {
  // const children = props.children
  // children.map((c,idx) =>c.key=idx)
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>
}

function MultiValue(props) {
  return (
    <Chip
      tabIndex={-1}
      label={props.children}
      className={classNames(props.selectProps.classes.chip, {
        [props.selectProps.classes.chipFocused]: props.isFocused
      })}
      onDelete={props.removeProps.onClick}
      deleteIcon={<CancelIcon {...props.removeProps} />}
    />
  )
}

function Menu(props) {
  return (
    <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
      {props.children}
    </Paper>
  )
}

const components = {
  Control,
  Menu,
  MultiValue,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer
}

class IntegrationReactSelect extends React.Component {
  state = {
    single: null,
    multi: null
  }

  // handleChange = name => value => {
  //   this.setState({
  //     [name]: value
  //   })
  // }

  render() {
    const { classes, className, theme, options, value, placeholder, onChange, loose, isMulti, isDisabled } = this.props
    // console.log(this.props)
    // if(Array.isArray(options))

    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit'
        }
      })
    }
    // needs to provide label in an object for the select to display in text field, it won't try to
    // find out which option is chosen based upon this label, will just display it, without it, placeholder is displayed
    // such as {label: blah}, other fields can be provided, but don't matter
    // this is every useful to multiple values such as
    // each option could be an complex type
    // {value: something, label: something's label, meta: anything else}
    // but value and label key are must, otherwise isMulti will fail to add more than 1 choice
    // loose api is the ccustomization to differentiate the dense/normal form

    // try to a chance for user to deselect
    const suggestions = [{ label: '', value: '', id: '', name: '' }, ...options]

    // 如果开始给值为0， 取第一选项做为default
    const convertedValue = value => {
      if (!value) {
        return null
      } else if (typeof value === 'string') {
        return value === '0' ? suggestions[1] : { label: value }
      } else {
        return value
      }
    }
    return (
      //className is something passed down from the parent, classes are the self-defined styles
      <div
        className={
          className +
          ' ' +
          classNames({
            [classes.root]: true,
            [classes.looseRoot]: this.props.loose
          })
        }
      >
        <NoSsr>
          <Select
            // key={'whykeyhere'}
            key={'key' + Math.random().toString(10)}
            classes={classes}
            styles={selectStyles}
            options={suggestions}
            loose={loose}
            isDisabled={isDisabled}
            components={components}
            // the placeholder will only show when the value=null not just empty {}
            // value={!value ? null : { label: value }}
            // value={value}
            value={convertedValue(value)}
            onChange={onChange}
            placeholder={placeholder ? placeholder : 'Search...'}
            isMulti={isMulti}
          />
        </NoSsr>
      </div>
    )
  }
}

IntegrationReactSelect.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
}

export default withStyles(styles, { withTheme: true })(IntegrationReactSelect)
